import React, { Component } from 'react';
import GraphicalEnvelope from 'components/instruments/envelope/GraphicalEnvelope.js';
import { connect } from "react-redux";
import EnvelopeTrackDropdown from './EnvelopeTrackDropdown.js';
import {
    setSelectedEnvelope,
    setContextualHelp} from 'actions/index.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {ENVELOPE_COMPONENT} from 'constants/contextual-help.js';
import ParameterKnob from 'components/knobs/ParameterKnob.js';
import EnvelopeModal from 'components/instruments/EnvelopeModal.js';

class SystemEnvelopeComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showEnvelopeModal: false,
            value: 0,
        };
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState({
                value: this.props.envelopeTrack.envelope.envelope.value,
            });
        }, 100);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }


    showEnvelopeModal(show=true) {
        this.setState({showEnvelopeModal: show})
    }

    isSelected() {
        if (this.props.hideSelection) {
            return false;
        }
        return this.props.selectedEnvelope === this.props.envelopeTrack.number;
    }

    render() {
        let nameClassName =
            "instrument-subsection-name lfo-subsection-name lfo-track-foreground-" +
            this.props.envelopeTrack.number;
        let envelope = this.props.envelopeTrack.envelope;
        let isSelected = this.isSelected();
        let className = isSelected ? 
            'envelope-component selected' : 'envelope-component';
        let number = this.props.envelopeTrack.number;
        className += " modulator-" +  number;
        let style = {
            width: (this.state.value * 100) + '%',
        };
        return (
            <div
              onClick={() => this.props.setSelectedEnvelope(this.props.envelopeTrack.number)}
              onMouseOver={() => this.props.setContextualHelp(ENVELOPE_COMPONENT)}
              onMouseLeave={() => this.props.setContextualHelp(undefined)}
              className={className}>
             <div className={nameClassName}>
                {this.props.envelopeTrack.name}
              </div>
              <EnvelopeTrackDropdown
                isSelected={isSelected}
                sequencerEngine={this.props.sequencerEngine}
                envelope={envelope}
                />
              <div className="clear-fix"/>
              <div className="knobs">
                <GraphicalEnvelope
                  name={"Env " + number}
                  envelope={envelope}
                  width={200}
                  hasRelease={true}
                  hasLevel={false}
                  sequencerEngine={this.props.sequencerEngine}/>
              </div>
                <div className="envelope-value-container">
                  <div className="envelope-value" style={style}/>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        selectedEnvelope: state.sequencer.selectedEnvelope,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setSelectedEnvelope: (envelope) => dispatch(setSelectedEnvelope(envelope)),
        setContextualHelp: (help) => dispatch(setContextualHelp(help))
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(SystemEnvelopeComponent);

